"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Rehabilitation = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Rehabilitation, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Rehabilitation);

  function Rehabilitation() {
    (0, _classCallCheck2["default"])(this, Rehabilitation);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Rehabilitation, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M8.33424544,11.8900747 C8.62940111,8.49362702 11.1230291,5.95726994 12.2154879,5.95726994 C13.1976344,5.95726994 13.4634932,6.82328433 13.9000549,7.71789075 C14.1524372,8.23519307 14.333804,8.60566509 14.5936082,9.13098423 L17.0526659,11.6170288 C17.1346189,11.6998825 17.1984469,11.7931225 17.2539936,11.8900352 L21.3478138,11.8900352 C21.7080865,11.8900747 22,12.1851965 22,12.5494289 C22,12.9136612 21.7080865,13.208783 21.3478138,13.208783 L20.6956275,13.208783 L20.6956275,21.3406459 C20.6956275,21.7048782 20.4037141,22 20.0434413,22 C19.6831686,22 19.3912551,21.7048782 19.3912551,21.3406459 L19.3912551,13.208783 L17.2539546,13.208783 C16.919463,13.7923919 16.0529413,14.3292032 14.9361075,13.208783 L10.9130295,13.208783 L10.9130295,20.6812918 C10.9130295,21.4084532 10.3279525,22 9.60869608,22 C8.88943967,22 8.30436269,21.4084532 8.30436269,20.6812918 L8.30436269,15.0988972 L8.30436269,13.208783 L4.6087449,13.2087435 L4.6087449,21.3406064 C4.6087449,21.7048387 4.31683141,21.9999605 3.95655868,21.9999605 C3.59628594,21.9999605 3.30437245,21.7048387 3.30437245,21.3406064 L3.30437245,13.208783 L2.65218623,13.208783 C2.29214787,13.208783 2,12.9136612 2,12.5494289 C2,12.1851965 2.29218693,11.8900747 2.65222529,11.8900747 L8.33424544,11.8900747 Z M15.0434901,2 C16.1223552,2 17.0000098,2.88730044 17.0000098,3.97802285 C17.0000098,5.06874525 16.1223552,5.95604569 15.0434901,5.95604569 C13.9646251,5.95604569 13.0869705,5.06874525 13.0869705,3.97802285 C13.0869705,2.88730044 13.9646251,2 15.0434901,2 Z M13.6293132,11.8900352 C13.0269316,11.2771234 12.4695889,10.6998331 12.410175,10.6018541 L11.7100201,9.44541748 C11.3250599,10.492541 11.0546698,11.1210521 10.9561934,11.8900352 L13.6293132,11.8900352 Z"
      }));
    }
  }]);
  return Rehabilitation;
}(_react["default"].PureComponent);

var _default = Rehabilitation;
exports["default"] = _default;